import React from "react";

const PatientInformation = ({ patient }) => {
  return (
    <div
      style={{
        borderRadius: "8px",
        border: "1px solid #ccc",
        padding: "20px",
        backgroundColor: "#fff",
        fontFamily: "sans-serif",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
        marginTop: "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: "1", minWidth: "300px", marginRight: "20px" }}>
          <InfoRow label="Nomor Pasien" value={patient?.patient_number ?? ""} />
          <InfoRow label="Nama Pasien" value={patient?.patient_name ?? ""} />
          <InfoRow
            label="Tanggal Lahir"
            value={patient?.patient_birthday ?? ""}
          />
          <InfoRow
            label="Jenis Kelamin"
            value={patient?.patient_gender ?? ""}
          />
        </div>

        <div style={{ flex: "1", minWidth: "300px" }}>
          <InfoRow label="Alamat" value={patient?.patient_address ?? ""} />
          <InfoRow
            label="No. Handphone"
            value={patient?.patient_phone_number ?? ""}
          />
          <InfoRow
            label="Poin Klinik"
            value={patient?.patient_clinic_point ?? ""}
          />
          <InfoRow
            label="Poin Apotek"
            value={patient?.patient_pharmacy_point ?? ""}
          />
        </div>
      </div>
    </div>
  );
};

const InfoRow = ({ label, value }) => (
  <div style={{ display: "flex", marginBottom: "12px" }}>
    <div style={{ width: "150px", fontWeight: "bold", color: "#333" }}>
      {label}:
    </div>
    <div style={{ color: "#555" }}>{value}</div>
  </div>
);

export default PatientInformation;
